import * as actionTypes from "./actionTypes";
import API from "../../axios/api";
import { toastr } from "react-redux-toastr";
import axios from "axios";
import { i18n } from '../../translate/i18n';
let CancelToken = axios.CancelToken;
let fetchQuicksight_cancel;
let checkDeleteQuicksight_cancel;

export const fetchQuicksightSuccess = permissions => {
  return {
    type: actionTypes.FETCH_QUICKSIGHT_SUCCESS,
    permissions: permissions
  };
};

export const requestQuicksightFail = error => {
  return {
    type: actionTypes.REQUEST_QUICKSIGHT_FAIL,
    error: error
  };
};

export const requestQuicksightStart = () => {
  return {
    type: actionTypes.REQUEST_QUICKSIGHT_START
  };
};

export const deleteQuicksightSuccess = permissions => {
  return {
    type: actionTypes.DELETE_QUICKSIGHT_SUCCESS,
    permissions: permissions
  };
};

export const updateQuicksightSuccess = permissions => {
  return {
    type: actionTypes.UPDATE_QUICKSIGHT_SUCCESS,
    permissions: permissions
  };
};

export const postQuicksightSuccess = permissions => {
  return {
    type: actionTypes.POST_QUICKSIGHT_SUCCESS,
    permissions: permissions
  };
};

export const fetchQuicksight = (page, limit, search, order, orderBy) => {
  fetchQuicksight_cancel && fetchQuicksight_cancel();
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestQuicksightStart());
      const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${
        !limit || limit < 5 ? 5 : limit
      }&q=${search ? search : ""}&sort=${
        order === "desc" ? "-" : ""
      }${orderBy}`;
      API.get("/quicksight" + queryParams, {
        cancelToken: new CancelToken(function executor(c) {
          fetchQuicksight_cancel = c;
        })
      })
        .then(res => {
          dispatch(fetchQuicksightSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestQuicksightFail(err));
          reject(err);
        });
    });
  };
};

export const deleteQuicksight = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestQuicksightStart());
      API.delete('/quicksight/' + index)
        .then(res => {
          dispatch(deleteQuicksightSuccess(res.data));
          toastr.success(i18n.t('deleteQuicksight.toastr'), `${res.data.name}${i18n.t('deleteQuicksight.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestQuicksightFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const postQuicksight = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestQuicksightStart());
      API.post('/quicksight', body)
        .then(res => {
          dispatch(postQuicksightSuccess(res.data));
          toastr.success(i18n.t('postQuicksight.toastr'), `${res.data.name}${i18n.t('postQuicksight.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestQuicksightFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postQuicksight.toastrError'), i18n.t('postQuicksight.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateQuicksight = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestQuicksightStart());
      API.put('/quicksight/' + index, body)
        .then(res => {
          dispatch(updateQuicksightSuccess(res.data));
          toastr.success(i18n.t('updateQuicksight.toastr'), `${res.data.name}${i18n.t('updateQuicksight.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestQuicksightFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updateQuicksight.toastrError'), i18n.t('updateQuicksight.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}
